const CATEGORIES = [
  {
    id: "sant",
    label: "संत / साधु-साध्वी",
    fields: [
      { name: "name", label: "नाम", type: "text", required: true },
      { name: "diksha", label: "दीक्षा तिथि", type: "date", required: true },
      { name: "guru", label: "गुरु का नाम", type: "text", required: true },
      { name: "sampraday", label: "सम्प्रदाय", type: "text", required: true },
      { name: "location", label: "वर्तमान स्थान", type: "text", required: true },
      { name: "mobile", label: "संपर्क नंबर", type: "tel", required: false },
      { name: "photo", label: "फोटो (URL)", type: "url", required: false },
      { name: "description", label: "परिचय", type: "textarea", required: false },
    ],
  },
  {
    id: "vidwan",
    label: "विद्वान / पंडित",
    fields: [
      { name: "name", label: "नाम", type: "text", required: true },
      { name: "qualification", label: "शैक्षणिक योग्यता", type: "text", required: true },
      { name: "specialization", label: "विशेषज्ञता", type: "text", required: true },
      { name: "city", label: "शहर", type: "text", required: true },
      { name: "mobile", label: "मोबाइल", type: "tel", required: true },
      { name: "email", label: "ईमेल", type: "email", required: false },
      { name: "photo", label: "फोटो (URL)", type: "url", required: false },
      { name: "description", label: "परिचय", type: "textarea", required: false },
    ],
  },
  {
    id: "sanstha",
    label: "संस्था / संगठन",
    fields: [
      { name: "orgName", label: "संस्था का नाम", type: "text", required: true },
      { name: "regNo", label: "पंजीयन क्रमांक", type: "text", required: false },
      { name: "established", label: "स्थापना वर्ष", type: "number", required: true },
      { name: "president", label: "अध्यक्ष का नाम", type: "text", required: true },
      { name: "city", label: "शहर", type: "text", required: true },
      { name: "mobile", label: "मोबाइल", type: "tel", required: true },
      { name: "email", label: "ईमेल", type: "email", required: false },
      { name: "photo", label: "लोगो / फोटो (URL)", type: "url", required: false },
      { name: "description", label: "संस्था का उद्देश्य", type: "textarea", required: false },
    ],
  },
  {
    id: "mandir",
    label: "मंदिर / तीर्थ",
    fields: [
      { name: "name", label: "मंदिर का नाम", type: "text", required: true },
      { name: "deity", label: "मूल नायक", type: "text", required: true },
      { name: "address", label: "पता", type: "text", required: true },
      { name: "city", label: "शहर", type: "text", required: true },
      { name: "state", label: "राज्य", type: "text", required: true },
      { name: "trustee", label: "ट्रस्टी / प्रबंधक", type: "text", required: true },
      { name: "mobile", label: "मोबाइल", type: "tel", required: true },
      { name: "photo", label: "फोटो (URL)", type: "url", required: false },
      { name: "description", label: "विशेष जानकारी", type: "textarea", required: false },
    ],
  },
  {
    id: "vyavsayi",
    label: "व्यवसायी / उद्यमी",
    fields: [
      { name: "name", label: "नाम", type: "text", required: true },
      { name: "business", label: "व्यवसाय का नाम", type: "text", required: true },
      { name: "sector", label: "क्षेत्र", type: "text", required: true },
      { name: "city", label: "शहर", type: "text", required: true },
      { name: "mobile", label: "मोबाइल", type: "tel", required: true },
      { name: "email", label: "ईमेल", type: "email", required: false },
      { name: "photo", label: "फोटो (URL)", type: "url", required: false },
      { name: "description", label: "परिचय", type: "textarea", required: false },
    ],
  },
];

export default CATEGORIES;
